import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';
import {EdlModalUserDirectory} from './edl-modal-user-directory.component';
import {ServiceModule} from '../services/service.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {ResizeSearchDirective} from './resize-search.directive';
import { LaddaModule } from '../../../node_modules/angular2-ladda';
import {EdlModalEvidence} from './edl-evidence-modal.component';
import {EdlModalConfirmNotes} from './edl-modal-confirm-notes/edl-modal-confirm-notes.component';
import {EdlModalSubmit} from './edl-modal-submit.component';
import { EdlModalSendMessage } from './edl-send-message-modal.component';
import { EdlModalDetails } from './edl-modal-details/edl-modal-details.component';
import { EdllModalNotesComponent } from './edl-modal-notes/edl-modal-notes.component';
import { ComponentModule } from '../components/components.module';
import { EdlModalArchiveItem } from './edl-modal-archive-item/edl-modal-archive-item.component';
import { EdlModalDuplicateItem } from './edl-modal-duplicate-item/edl-modal-duplicate-item.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EdlModalAdvancedRosterSearch } from './edl-advanced-roster-search/edl-modal-advanced-roster-search.component';
import { EdlModalApiResponse } from './edl-modal-api-response/edl-modal-api-response.component';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonModalModule, EdlCommonPipesModule } from '@edl-development/edl-common';
import { ComplyDirectivesModule } from '../directives/comply-directives.module';

@NgModule({
    imports: [
        CommonModule,
        EdlCommonModalModule,
        ComponentModule,
        EdlCommonComponentsModule,
        ServiceModule,
        NgbModule,
        FormsModule,
        NgSelectModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        EdlCommonPipesModule,
        PipesModule,
        LaddaModule,
        ErrorTailorModule
    ],
    providers: [
        ModalService
    ],
    declarations: [
        EdlModalAdvancedRosterSearch,
        EdlModalApiResponse,
        EdlModalArchiveItem,
        EdlModalUserDirectory,
        ResizeSearchDirective,
        EdlModalEvidence,
        EdlModalConfirmNotes,
        EdlModalDetails,
        EdlModalSubmit,
        EdlModalSendMessage,
        EdllModalNotesComponent,
        EdlModalDuplicateItem
    ],
    exports: [
        ResizeSearchDirective,
        EdlModalDetails,
        EdlModalApiResponse
    ]
})
export class ModalModule {}